export const navList = [
  {
    id: 1,
    name: '회사소개',
    path: '/company',
    sub: [
      { name: '인사말', path: '/comapny/1' },
      { name: '약력', path: '/company/2' },
      { name: '조직도', path: '/company/3' },
      { name: '특허', path: '/company/4' },
      { name: '오시는 길', path: '/company/5' },
    ],
  },
  {
    id: 2,
    name: '제품소개',
    path: '/product',
    sub: [
      { name: '제품소개', path: '/' },
      { name: '제품소개', path: '/' },
      { name: '제품소개', path: '/' },
    ],
  },
  {
    id: 3,
    name: '기술소개',
    path: '/technology',
    sub: [
      { name: '기술소개', path: '/' },
      { name: '기술소개', path: '/' },
      { name: '기술소개', path: '/' },
    ],
  },
  {
    id: 4,
    name: '커뮤니티',
    path: '/community',
    sub: [
      { name: '공지사항', path: '/community/notice' },
      { name: '견적문의', path: '/community/inquiry' },
      { name: 'Q&A', path: '/community/qna' },
      { name: '자료실', path: '/community/archive' },
    ],
  },
]

export const langList = [
  { label: 'KO', value: 'ko' },
  { label: 'EN', value: 'en' },
];
